
define('app/board/views/queueItemView',[
	'jquery',
	'underscore',
	'backbone',
	'known/models/userModel',
	'app/board/collections/pickSummaryCollection',
	'app/board/collections/queueCollection',
	'known/models/leagueInstanceModel',
	'app/board/models/draftStatusModel',
	'app/board/models/positionColorsModel',
	'app/board/models/pickModel',
	'app/board/models/queueItemModel',
	'app/board/util/playerList',
	
	//Templates
	'text!app/board/templates/queueItemTemplate.html'
], function(
		$, 
		_, 
		Backbone, 
		UserModel, 
		PickSummaryCollection,
		QueueCollection,
		LeagueInstanceModel, 
		DraftStatusModel, 
		PositionColorsModel,
		PickModel,
		QueueItemModel,
		PlayerList, 
		queueItemHtml){
	var QueueItemView = Backbone.View.extend({
		
		initialize: function(options) {
			this.draftStatus = options.draftStatus; //
			this.leagueInstance = options.leagueInstance; //
			this.user = options.user; //
			this.pickSummaryCollection = options.pickSummaryCollection; //
			this.posColors = options.posColors; //
			this.queueCollection = options.queueCollection; //
			this.queueItem = options.queueItem; //
			
			_.bindAll(this, 'draftPlayer');
			_.bindAll(this, 'updateBtnVisuals');
			_.bindAll(this, 'removeFromQueue');
			
			this.listenTo(this.posColors, 'change', this.updateColor);
			this.draftStatus.bind("change", this.updateBtnVisuals, this);
			
			this.queueItemTemplate = _.template(queueItemHtml.trim());
			
			this.buildEl();
			
			this.$el.find('.queueDraftPlayerBtn').on('click', {}, this.draftPlayer);
			this.$el.find('.removeQueueItemBtn').on('click', {}, this.removeFromQueue);
		},
		
		render: function () {
			
			
			return this;
		},
		
		buildEl: function() {
			var teamAbbr = (this.queueItem.get('byeWeek') && this.queueItem.get('byeWeek') > 0) 
					? this.queueItem.get('teamAbbr')+'('+this.queueItem.get('byeWeek')+')' 
					: this.queueItem.get('teamAbbr');
			
			this.setElement($(this.queueItemTemplate({
				playerName: this.playerNameText(),
				playerPos: this.queueItem.get('playerPos'),
				teamAbbr: teamAbbr})));
			
			this.updateColor();
			this.updateBtnVisuals();
		},
		
		playerNameText: function() {
			var dispName = this.queueItem.get('lName');
			
			if(this.queueItem.get('fName')){
				dispName += ', ' + this.queueItem.get('fName');
			}
			
			return dispName; 
		},
		
		removeFromQueue: function() {
			this.queueCollection.remove(this.queueItem);
		},
		
		draftPlayer: function() {
			var round = this.draftStatus.get('round');
			var posInRound = this.draftStatus.get('posInRound');
			var fantTeamId = this.draftStatus.get('draftingTeamId');
			var keeper = false;
			var autoDrafted = false;
			
			//var pickSum = this.pickSummaryCollection.get(this.pickSummaryCollection.getPosRoundId(this.draftStatus.get('round'), this.draftStatus.get('posInRound')));
			//var value = pickSum.get('ovrPickNum');
			
			var newPick = new PickModel({
				leagueId : this.leagueInstance.get('leagueId'),
				leagueInstanceId : this.leagueInstance.get('id'),
				fantasyTeamId : fantTeamId,
				draftablePlayerId : this.queueItem.get('id'),
				//value : value,
				round : round,
				posInRound: posInRound,
				keeper : keeper,
				autoDrafted : autoDrafted});
			
			newPick.save();
		},
		
		updateColor: function() {
			var color = this.posColors.retrievePosColor(this.queueItem.get('playerPos'));
			this.$el.find('td').css({'background-color': color});
		},
		
		updateBtnVisuals: function() {
			if(this.leagueInstance.get('draftStatus') == 'STARTED'){
				var fantTeamId = this.draftStatus.get('draftingTeamId');
				var allowedPositions = this.draftStatus.get('allowedPositions')[fantTeamId];
				
				if(_.intersection(allowedPositions,this.queueItem.get('playerPos').split(',')).length > 0){
					var curFantTeamId = -1;					
					
					if(this.leagueInstance.get('draftType') == 'AUCTION') {
						if(!this.draftStatus.get('auctionBidding')){
							curFantTeamId = this.draftStatus.get('draftingTeamId');
						}
					} else {
						var pickSum = this.pickSummaryCollection.get(
								this.pickSummaryCollection.getPosRoundId(this.draftStatus.get('round'), this.draftStatus.get('posInRound'))
								);
						
						if(pickSum){
							curFantTeamId = pickSum.get('fantasyTeamId');
						}
					}
					
					
					
					if(curFantTeamId > 0){
						var teamOwner = this.leagueInstance.getTeamOwner(curFantTeamId);
						var userName = this.user.get('userName');
						var isAssistant = this.leagueInstance.isAssistant(userName);
						
						//Change color of button for commish
						if(isAssistant && userName.toUpperCase() != teamOwner.toUpperCase()){
							this.$el.find('.queueDraftPlayerBtn').removeClass('btn-success');
							this.$el.find('.queueDraftPlayerBtn').addClass('btn-info');
							this.$el.find('.queueDraftPlayerBtn').css({'display': ''});
						} else if(userName.toUpperCase() == teamOwner.toUpperCase()){
							this.$el.find('.draftRankedPlayerBtn').removeClass('btn-info');
							this.$el.find('.draftRankedPlayerBtn').addClass('btn-success');
							this.$el.find('.queueDraftPlayerBtn').css({'display': ''});
						} else {
							this.$el.find('.queueDraftPlayerBtn').css({'display': 'none'});
						}
					} else {
						this.$el.find('.queueDraftPlayerBtn').css({'display': 'none'});
					}
				} else {
					this.$el.find('.queueDraftPlayerBtn').css({'display': 'none'});
				}
			} else {
				this.$el.find('.queueDraftPlayerBtn').css({'display': 'none'});
			}
		},
		
		destroyView: function() {
	    	this.stopListening();
	    	this.undelegateEvents();
	    	
	    	//Remove DOM
	    	$(this.el).removeData().unbind();
	    	this.remove();  
	    	Backbone.View.prototype.remove.call(this);
        }
	});
	
	return QueueItemView;  
});